let showcaseImages = null;
let segNav = null;

$(document).ready(function () {
    var notice = document.getElementById('klaro-cookie-notice');
    if (notice) {
        notice.classList.add('is-visible');
    }

    new Accordion('[data-accordion-header]');
    new Slider();
    new MobileNavigation();

    $('.cookie--change').on('click tap', function (e) {
        klaroConfig.consents = []; // Leere die Zustimmungen

// Klaro! Consent Manager-Fenster erneut anzeigen
        klaroConfig.mustConsent = true; // Setze mustConsent auf true, um das Einwilligungsfenster zu erzwingen
        klaro.show(); // Zeige das Einwilligungsfenster für den Dienst "alle" an
        setTimeout(function () {
            $('#klaro a').first().focus();
        }, 1000); // Hier kannst du die Zeit anpassen, um sicherzustellen, dass das Klaro!-Fenster gerendert wurde

        e.preventDefault();
    });

    function updatePhoneTime() {
        const now = new Date();
        const hours = now.getHours();
        const minutes = String(now.getMinutes()).padStart(2, "0");
        const timeString = `${hours}:${minutes}`;
        const options = { weekday: 'long', day: 'numeric', month: 'long' };
        const dateString = now.toLocaleDateString(undefined, options);

        document.querySelectorAll(".el-preview--phone__time")
            .forEach(el => el.textContent = timeString);

        document.querySelectorAll(".el-preview--phone__locktime-time")
            .forEach(el => el.textContent = timeString);

        document.querySelectorAll(".el-preview--phone__locktime-date")
            .forEach(el => el.textContent = dateString);
    }

    updatePhoneTime();

    new ChromaColor();

    var $scope = $('.el-co__wrapper .htmleditor');
    var svgMarkup =
        '<svg class="svg-item icon--check" viewBox="0 0 100 100" aria-hidden="true" focusable="false">' +
        '<use xlink:href="#icon--check"></use>' +
        '</svg>';

    if ($scope.length) {
        $scope.find('li').each(function () {
            var $li = $(this);
            if ($li.children('svg.icon--check').length) return;
            $li.prepend(svgMarkup);
        });
    }
});

window.addEventListener("load", async () => {

    if (segNav) segNav.destroy();
    segNav = new SegmentNavigation({
        linkSelector: ".aside__link",
        activeClass: "current",
        scroller: undefined
    });

    (function ($) {
        const $form = $('#project-filter-form');
        const $results = $('#project-results');
        const $status = $('#project-results-status');

        if (!$form.length || !$results.length) {
            return;
        }

        function loadProjects() {
            $results.attr('aria-busy', 'true');

            if ($status.length) {
                $status.text('Projekte werden geladen.');
            }

            $.ajax({
                url: $form.attr('action'),
                method: 'GET',
                data: $form.serialize(),
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                success: function (html) {
                    $results.html(html);

                    const count = $results.find('.el-ps--grid__showcase__item').length;

                    if ($status.length) {
                        $status.text(count + ' Projekte gefunden.');
                    }
                },
                error: function () {
                    if ($status.length) {
                        $status.text('Die Projekte konnten nicht geladen werden.');
                    }
                },
                complete: function () {
                    $results.attr('aria-busy', 'false');
                }
            });
        }

        $form.on('change', '.js-filter-all', function () {
            const $fieldset = $(this).closest('fieldset');

            if ($(this).is(':checked')) {
                $fieldset.find('.js-filter-item').prop('checked', false);
            } else {
                $(this).prop('checked', true);
            }

            loadProjects();
        });

        $form.on('change', '.js-filter-item', function () {
            const $fieldset = $(this).closest('fieldset');
            const $all = $fieldset.find('.js-filter-all');

            if ($(this).is(':checked')) {
                $all.prop('checked', false);
            }

            if ($fieldset.find('.js-filter-item:checked').length === 0) {
                $all.prop('checked', true);
            }

            loadProjects();
        });

    })(jQuery);
});